<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'pre-cart-check',
  async mounted() {
    // Check if Staged Tickets has content - https://lodash.com/docs#isEmpty
    if(!_.isEmpty(this.performance.stagedTickets)) {
      this.updateLoading(true);
      this.updateStage("pre-cart-check");

      await this.submitTickets();
    } else {
      // If stageTickets is empty; user has arrived via the browser back button
      // Therefore send them to the start of this purchase path flow
      this.$router.push({ name: "choose-seat-flow", params: { icc: this.$route.params.icc, locale: this.$i18n.locale } });
    }
  },
  methods: {
    async submitTickets() {
      const ticketTypeCodes = Object.keys(this.performance.stagedTickets);

      // ticketTypeCode is priceClassCode that defines the type of the ticket type.
        let priceClassMap = [];
      for (const key of ticketTypeCodes) {
        // Define priceClassMap
        let ticketType = this.performance.stagedTickets[key];
        let quantity = this.performance.stagedTickets[key].quantity;

        if (ticketType.promoPassword) {
          priceClassMap.push(`${key}:${quantity}|${ticketType.promoPassword}`)
        } else {
          priceClassMap.push(`${key}:${quantity}`);
        }
      }

        this.payload = {
          cartGuid: this.cart.cartGuid,
          productId: this.performance.productId,
          priceClassMap: priceClassMap.join(','),
          mode: this.performance.mode,
        };

        if (this.performance.priceCategoryId != -1) {
          this.payload.priceCatId = this.performance.priceCategoryId;
          this.payload.seatSectionId = this.performance.seatSectionId;
        }

        // Need to add seat inventory IDs if we're dealing with SP/BA/HS
        // i.e. GA does not require seat inventory IDs
        let inventoryList = [];
        let stagingReservedList = this.cart.inventoryIdsReservedList;

        if (this.performance.mode === "SP") {
          stagingReservedList.forEach((item) => {
            inventoryList.push(item);
          });
        }

        if (this.performance.mode === "BA" || this.performance.mode === "HS") {
          stagingReservedList.forEach((item) => {
            inventoryList.push(item.inventoryId);
          });
        }

        if(inventoryList.length > 0) {
          // Add the seatIds (total array split by chosen ticket types - where relevant).
          this.payload.inventoryList = inventoryList;
        }

        let submission = await this.sendToCart(this.payload);

        if(submission === true) {
          // Update inventoryIdsReservedList, such that it no longer contains the inventory IDs we just successfully added
          await this.updateInventoryReservedList([]);
          this.updateStagedTickets({})
          this.$router.push({ name: "shopping-cart", params: { locale: this.$i18n.locale } });
        } else {
          // in the future non-member notice logic should exist here
          // for now we're sending users back to choose-tickets screen
          this.failedSubmissions();
        }
    },
    failedSubmissions() {
      this.updateLoading(true)
      this.updateStagedTickets({})
      this.$router.push({ name: "choose-seat-flow", params: { icc: this.performance.stagedIccCode, issue: 'cart-addition-issue', locale: this.$i18n.locale } })
    },
    ...mapActions([
      'updateLoading',
      'updateStagedTickets',
      'updateInventoryReservedList',
      'sendToCart',
      'updateStage'
    ])
  },
  computed: {
    ...mapState(['cart', 'performance'])
  }
}
</script>